import { render, staticRenderFns } from "./labelNew.vue?vue&type=template&id=41a4f220&scoped=true&"
import script from "./labelNew.vue?vue&type=script&lang=js&"
export * from "./labelNew.vue?vue&type=script&lang=js&"
import style0 from "./labelNew.vue?vue&type=style&index=0&id=41a4f220&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a4f220",
  null
  
)

export default component.exports